import React, { useContext } from 'react';
import { number, oneOfType, shape, string } from 'prop-types';
import { StoreMapPreview } from '@thd-olt-component-react/store-map';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

export const StorePodMap = ({ mapOptions, placeholderOptions }) => {
  const { loading, store } = useContext(StorePodContext);

  if (loading) {
    return (
      <div
        data-testid="store-pod-map-loader"
        style={{ width: placeholderOptions.width }}
        data-component="StorePodMapLoader"
      >
        <StorePodLoader height={placeholderOptions.height} />
      </div>
    );
  }

  return (
    <div data-testid="store-pod-map" data-component="StorePodMap">
      <StoreMapPreview mapOptions={mapOptions} store={store} />
    </div>
  );
};

StorePodMap.displayName = 'StorePodName';

StorePodMap.propTypes = {
  mapOptions: shape({
    height: oneOfType([string, number]),
    width: oneOfType([string, number]),
    zoom: oneOfType([string, number])
  }),
  placeholderOptions: shape({
    height: string,
    width: string,
  }),
};

StorePodMap.defaultProps = {
  mapOptions: {
    height: '100',
    width: '100',
    zoom: '13'
  },
  placeholderOptions: {
    height: '100px',
    width: '100%',
  },
};
